export default __webpack_public_path__ + "static/media/disabledpot.f1bc86ed.svg";